module.exports = __webpack_public_path__ + "assets/img/b0821dc423014828462c29fe51e9de43.png";